import React, { useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';

const StatisticsCard = ({ statistics }) => {
  console.log('[StatisticsCard] Rendering with statistics:', statistics);
  
  useEffect(() => {
    console.log('[StatisticsCard] Component mounted/updated with statistics:', statistics);
    return () => console.log('[StatisticsCard] Component unmounting');
  }, [statistics]);
  if (!statistics) {
    console.log('[StatisticsCard] No statistics data available, showing loading state');
    return <div>Loading statistics...</div>;
  }

  // Log specific statistics of interest
  console.log('[StatisticsCard] Key metrics:', {
    totalMessages: statistics.nr_messages || 0,
    messagesWithCaseIds: statistics.nr_messages_with_valid_case_id || 0,
    messagesWithActivity: statistics.nr_messages_with_activity_processed || 0,
    totalCases: statistics.nr_cases || 0,
    unprocessedCaseId: statistics.nr_messages_case_id_unprocessed || 0,
    unprocessedActivity: statistics.nr_messages_with_activity_unprocessed || 0
  });
  
  return (
    <div className="mb-1">
      <h3>Basic Statistics</h3>
      <Row>
        <Col md={4} className="mb-3">
          <Card className="h-100">
            <Card.Body>
              <Card.Title>Message Data</Card.Title>
              {/* <Card.Text> */}
                <div className="d-flex justify-content-between">
                  <span>Total Messages:</span>
                  <span className="fw-bold">{statistics.nr_messages || 0}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Messages with Case ID:</span>
                  <span className="fw-bold">{statistics.nr_messages_with_valid_case_id || 0}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Messages with Activity:</span>
                  <span className="fw-bold">{statistics.nr_messages_with_activity_processed || 0}</span>
                </div>
              {/* </Card.Text> */}
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card className="h-100">
            <Card.Body>
              <Card.Title>Case Data</Card.Title>
              {/* <Card.Text> */}
                <div className="d-flex justify-content-between">
                  <span>Total Cases:</span>
                  <span className="fw-bold">{statistics.nr_cases || 0}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Native Events:</span>
                  <span className="fw-bold">{statistics.nr_native_events || 0}</span>
                </div>
              {/* </Card.Text> */}
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card className="h-100">
            <Card.Body>
              <Card.Title>Processing Status</Card.Title>
              {/* <Card.Text> */}
                <div className="d-flex justify-content-between">
                  <span>Unprocessed Case ID:</span>
                  <span className="fw-bold">{statistics.nr_messages_case_id_unprocessed || 0}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Unprocessed Activity:</span>
                  <span className="fw-bold">{statistics.nr_messages_with_activity_unprocessed || 0}</span>
                </div>
              {/* </Card.Text> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default StatisticsCard;